// body#checkout

import Big from 'big.js';
import axios, { AxiosStatusCode } from 'smg/axios';
import * as buttons from 'smg/buttons';
import * as countries from 'smg/countries';
import * as smgCarts from 'smg/customer-api/carts';
import * as paymentoptions from 'smg/customer-api/paymentoptions';
import * as session from 'smg/customer-api/session';
import { UserDetails } from 'smg/customer-api/users';
import * as errors from 'smg/errors';
import * as filepath from 'smg/filepath';
import { ReportValidity } from 'smg/form';
import Modal from 'smg/modal';
import * as models from 'smg/models';
import { CleanNumber } from 'smg/number';
import * as object from 'smg/object';
import { CanAmount } from 'smg/paymentoptiontypes';
import * as phone from 'smg/phone';
import { G } from 'smg/querystring';
import * as strings from 'smg/strings';
import * as template from 'smg/template';
import * as uploads from 'smg/uploads';
import { Debounce, DollarFormat } from 'smg/util';
import { UUID } from 'smg/uuid';
import * as carts from '../carts';
import { Relref } from '../hugo';
import * as lineitems from '../lineitems';
import * as payments from '../payments';
import * as shippingoptions from '../shippingoptions';
import { CheckPOBoxAddress, CheckPOBoxNewAddress } from '../shippingoptions';
import * as usertaxexemptions from '../usertaxexemptions';

declare interface myWindow extends Window {
    readonly staxOmniWebPaymentsToken: string;
    readonly cloudFront: string;
    // dataLayer: Record<string, unknown>[];
    orderPayments: newOrderPayment[];
    deleteOrderPayment(orderPayment: newOrderPayment): void;
}
declare const window: myWindow;
declare interface createOrderResp {
    orderID: string;
    invoiceNumber: number;
    key: string;
}

interface hasCountryAndState {
    countryID?: number;
    country?: models.Country;
    stateID?: number;
    state?: models.State;
}

async function updateCountryAndState(obj: hasCountryAndState) {
    delete obj.country;
    delete obj.state;

    if (obj.countryID) {
        const country = await countries.GetCountry(obj.countryID);
        if (country) {
            obj.country = {
                countryCode2: country?.countryCode2,
                countryCode3: country?.countryCode3,
                id: country?.id,
                name: country?.name,
            };

            if (obj.stateID) {
                const state = await countries.GetState(obj.countryID, obj.stateID);
                obj.state = {
                    stateCode: state?.stateCode,
                    id: state?.id,
                    name: state?.name,
                };
            }
        }
    }
}

interface newOrderPayment {
    el: HTMLElement;
    orderPayment: models.OrderPayment;

    poUploader?: uploads.Uploader;
    poNumberEl?: HTMLInputElement;
    paymentAmountContainer?: HTMLElement;
    paymentAmount?: HTMLInputElement;

    createPaymentOption?: () => Promise<models.PaymentOption>;
    createOrderPayment?: (orderID: string) => Promise<void>;
    charged?: boolean;
}

export default async function main() {
    const quoteID = G().Get('quote');
    const reorderID = G().Get('order');
    const cartID = G().Get('cart');
    if (quoteID) {
        await carts.AddCartItem({ quoteID }, {
            promptToCheckout: false,
            hideCartLink: true,
            showToast: false,
            newCart: true,
        }).catch(() => window.location.href = `${Relref('/cart')}?quote=${G().Get('quote') || ''}`);
    } else if (reorderID) {
        await carts.AddCartItem({ orderID: reorderID }, {
            promptToCheckout: false,
            hideCartLink: true,
            showToast: false,
            newCart: true,
        }).catch(() => window.location.href = `${Relref('/cart')}?quote=${G().Get('order') || ''}`);
    } else if (cartID) {
        await carts.AddCartItem({ cartID }, {
            promptToCheckout: false,
            newCart: true,
        });
    }

    void smgCarts.CartAutoReload();

    let shippingOption: models.ShippingOption = {};
    let userTaxExemption: models.UserTaxExemption | undefined;
    const orderPayments: newOrderPayment[] = [];
    let promoCode: models.PromotionalCode | undefined;

    const form = document.querySelector('#checkout-form') as HTMLFormElement;
    const fieldset = form.querySelector('fieldset') as HTMLFieldSetElement;
    const placeOrder = document.querySelector('#checkout-button') as HTMLButtonElement;

    const shippingCard = document.querySelector('#shipping-card') as HTMLElement;
    const shippingFieldset = shippingCard.querySelector('#shipping-fieldset') as HTMLFieldSetElement;
    const shippingSpinner = shippingCard.querySelector('.spinner-parent') as HTMLElement;
    const shippingEdit = shippingCard.querySelector('.edit') as HTMLAnchorElement;
    const shippingAddress = shippingCard.querySelector('#shipping-address') as HTMLElement;
    const shippingForm = shippingCard.querySelector('#shipping-form') as HTMLElement;
    const shippingFullName = shippingCard.querySelector('#shipping-full-name') as HTMLInputElement;
    const shippingCompany = shippingCard.querySelector('#shipping-company') as HTMLInputElement;
    const shippingAddressLine1 = shippingCard.querySelector('#shipping-address-line-1') as HTMLInputElement;
    const shippingAddressLine2 = shippingCard.querySelector('#shipping-address-line-2') as HTMLInputElement;
    const shippingCity = shippingCard.querySelector('#shipping-city') as HTMLInputElement;
    const shippingZip = shippingCard.querySelector('#shipping-zip') as HTMLInputElement;
    const shippingCountry = shippingCard.querySelector('#shipping-country') as HTMLSelectElement;
    const shippingState = shippingCard.querySelector('#shipping-state') as HTMLSelectElement;
    const shippingPhoneEl = shippingCard.querySelector('#shipping-phone') as HTMLInputElement;
    const shippingPhone = new phone.Phone(shippingPhoneEl);
    const shippingEmail = shippingCard.querySelector('#shipping-email') as HTMLInputElement;
    const nonUsAlert = document.querySelector('#non-us-alert') as HTMLElement;

    const userTaxExemptionCard = document.querySelector('#tax-card') as HTMLElement;
    const userTaxExemptionFieldset = userTaxExemptionCard.querySelector('#tax-fieldset') as HTMLFieldSetElement;
    const userTaxExemptionSpinner = userTaxExemptionCard.querySelector('.spinner-parent') as HTMLElement;
    const userTaxExemptionEdit = userTaxExemptionCard.querySelector('.edit') as HTMLAnchorElement;
    const userTaxExemptionEl = userTaxExemptionCard.querySelector('.user-tax-exemption') as HTMLElement;
    const userTaxExemptionForm = userTaxExemptionCard.querySelector('#tax-form') as HTMLElement;
    const userTaxExemptionAdditionalFields = userTaxExemptionForm.querySelector('#user-tax-exemption-additional-fields') as HTMLFieldSetElement;
    const userTaxExemptNumber = userTaxExemptionForm.querySelector('#user-tax-exemption-number') as HTMLInputElement;
    const userTaxCountry = userTaxExemptionForm.querySelector('#user-tax-exemption-country') as HTMLSelectElement;
    const userTaxState = userTaxExemptionForm.querySelector('#user-tax-exemption-state') as HTMLSelectElement;
    const userTaxUpload = userTaxExemptionForm.querySelector('#user-tax-exemption-uploads') as HTMLLabelElement;
    const userTaxThumbnails = userTaxExemptionForm.querySelector('#user-tax-exemption-uploads-thumbnails') as HTMLElement;

    const billingCard = document.querySelector('#billing-card') as HTMLElement;
    const billingSpinner = billingCard.querySelector('#billing-spinner') as HTMLElement;
    const billingFooter = billingCard.querySelector('.card-footer') as HTMLElement;
    const splitPayment = billingCard.querySelector('#split-payment') as HTMLButtonElement;
    let paymentsEditedByUser = false;

    const sidebarFieldset = document.querySelector('#sidebar-fieldset') as HTMLFieldSetElement;
    const cartSubtotalEls = document.querySelectorAll('.cart-subtotal');
    const cartDiscountEls = document.querySelectorAll('.cart-discount');
    const cartShippingEls = document.querySelectorAll('.cart-shipping');
    const cartShippingSpinners = document.querySelectorAll('.cart-shipping-spinner');
    const cartTaxEls = document.querySelectorAll('.cart-tax');
    const cartTaxRateParents = document.querySelectorAll('.cart-tax-rate-parent');
    const cartTaxRateEl = document.querySelectorAll('.cart-tax-rate');
    const cartTaxSpinners = document.querySelectorAll('.cart-tax-spinner');
    const cartTotalEls = document.querySelectorAll('.cart-total');

    const caseStudy = document.querySelector('#case-study') as HTMLInputElement;
    const sms = document.querySelector('#sms-opt-in') as HTMLInputElement;

    const cartPaymentContainer = document.querySelector('#cart-payment-container') as HTMLElement;
    const nonPaymentWarning = cartPaymentContainer.querySelector('#non-payment-warning') as HTMLElement;
    const cartPaymentWarnIcon = cartPaymentContainer.querySelector('i') as HTMLElement;
    const cartPayment = document.querySelectorAll('.cart-payment');
    // const paypalCheckbox = document.querySelector('#paypal-radio') as HTMLInputElement;
    // const or = document.querySelector('#or') as HTMLElement;

    // paypalCheckbox.addEventListener('change', () => {
    //     if (paypalCheckbox.checked) {
    //         const paymentContainers = Array.from(document.querySelectorAll<HTMLFieldSetElement>('.payment-template'));

    //         for (const paymentOption of paymentContainers) {
    //             paymentOption.disabled = true;
    //             paymentOption.classList.add('d-none');

    //             placeOrder.textContent = 'Continue to PayPal';
    //             splitPayment.classList.add('d-none');
    //             or.classList.add('d-none');
    //         }
    //     } else {
    //         const paymentOptions = Array.from(document.querySelectorAll('.payment-template'));

    //         for (const paymentOption of paymentOptions) {
    //             paymentOption.classList.remove('d-none');
    //             paymentOption.removeAttribute('disabled');
    //         }

    //         placeOrder.textContent = 'Place Order';
    //         splitPayment.classList.remove('d-none');
    //         or.classList.remove('d-none');
    //     }
    //     drawCartTotals();
    // });

    const paymentTotal = () => {
        let t = Big(0);
        // if (paypalCheckbox.checked) {
        //     t = total;
        // } else {
        for (const newOrderPayment of orderPayments) {
            if (CanAmount(newOrderPayment.orderPayment.paymentOption?.paymentOptionTypeID)) {
                t = t.add(newOrderPayment.orderPayment.total || 0);
            }
        }
        // }
        return t;
    };

    const deleteOrderPayment = async (orderPayment: newOrderPayment) => {
        orderPayment.el.parentElement?.removeChild(orderPayment.el);
        orderPayments.splice(orderPayments.indexOf(orderPayment), 1);

        if (orderPayments.length === 1 &&
            orderPayments[0].orderPayment.paymentOption?.paymentOptionTypeID !== models.PaymentOptionTypeID.PAYMENT_OPTION_TYPE_BALANCE) {
            orderPayments[0].paymentAmountContainer?.classList.add('d-none');
            if (orderPayments[0].paymentAmount) {
                orderPayments[0].paymentAmount.disabled = true;
            }
        }

        if (orderPayments.length === 1 && CanAmount(orderPayments[0].orderPayment.paymentOption?.paymentOptionTypeID)) {
            orderPayments[0].orderPayment.total = total.toString();
            nonPaymentWarning.classList.add('d-none');
        }

        if (orderPayments.length === 1) {
            paymentsEditedByUser = false;
            await updateUnmodifiedPaymentAmounts();
        }

        drawCartTotals();
    };

    window.orderPayments = orderPayments;
    window.deleteOrderPayment = deleteOrderPayment;

    const newEmptyOrderPayment = async (paymentOption?: models.PaymentOption): Promise<newOrderPayment> => {
        const el = template.Clone('.order-payment-template').querySelector('.card-body') as HTMLFieldSetElement;

        const suffix = `-${UUID()}`;
        el.querySelectorAll('[id]:not([id=""])').forEach(el => {
            el.classList.add(el.id);
            el.id = `${el.id}${suffix}`;
        });
        el.querySelectorAll('label[for]:not([for=""])').forEach(el => el.setAttribute('for', `${el.getAttribute('for') || ''}${suffix}`));
        el.querySelectorAll('input[type="radio"][name]:not([name=""])').forEach(el => el.setAttribute('name', `${el.getAttribute('name') || ''}${suffix}`));

        const newOrderPayment: newOrderPayment = { el, orderPayment: { paymentOption: paymentOption ?? {} } };
        const spinner = el.querySelector('.order-payment-spinner') as HTMLElement;
        const newPaymentOptionContainer = el.querySelector('.billing-form') as HTMLFieldSetElement;
        const paymentOptionContainer = el.querySelector('.payment-option') as HTMLElement;
        const paymentFieldsContainer = el.querySelector('.payment-fields-parent') as HTMLElement;
        const orderPaymentFields = el.querySelector('.order-payment-fields') as HTMLElement;
        const edit = el.querySelector('.edit') as HTMLAnchorElement;
        const remove = el.querySelector('.remove') as HTMLAnchorElement;
        newOrderPayment.paymentAmountContainer = el.querySelector('.payment-amount-container') as HTMLElement;
        newOrderPayment.paymentAmount = el.querySelector('.payment-amount') as HTMLInputElement;

        newOrderPayment.paymentAmount.addEventListener('input', () => {
            newOrderPayment.orderPayment.total = CleanNumber(newOrderPayment.paymentAmount?.value || '0');
            paymentsEditedByUser = true;
            drawCartTotals();
        });

        const firstPaymentOption = orderPayments.length === 0;
        if (!firstPaymentOption) {
            el.classList.add('border-top', 'border-3');

            remove.classList.remove('d-none');
            remove.addEventListener('click', async e => {
                e.preventDefault();
                paymentsEditedByUser = true;
                await deleteOrderPayment(newOrderPayment);
            });
        } else if (newOrderPayment.orderPayment.paymentOption?.paymentOptionTypeID !== models.PaymentOptionTypeID.PAYMENT_OPTION_TYPE_BALANCE) {
            newOrderPayment.paymentAmountContainer.classList.add('d-none');
            newOrderPayment.paymentAmount.disabled = true;
        }

        if (newOrderPayment.orderPayment.paymentOption?.id) {
            newPaymentOptionContainer.classList.add('d-none');
            newPaymentOptionContainer.disabled = true;

            const drawPaymentOption = () => {
                if (newOrderPayment.orderPayment.paymentOption) {
                    void payments.DrawPaymentOption(newOrderPayment.orderPayment.paymentOption, newOrderPayment.orderPayment).then(paymentOptionEl => {
                        paymentOptionContainer.innerHTML = '';
                        paymentOptionContainer.appendChild(paymentOptionEl);
                    });
                }
            };
            drawPaymentOption();

            edit.classList.remove('d-none');
            edit.addEventListener('click', async e => {
                e.preventDefault();
                await payments.PromptPaymentOption(userDetails(), undefined, undefined, true).then(p => {
                    newOrderPayment.orderPayment.paymentOption = p;
                    paymentsEditedByUser = true;
                    drawPaymentOption();
                    drawOrderPaymentFields();
                    drawCartTotals();
                });
            });
        } else {
            const paymentOptionFields = new payments.PaymentOptionFields(
                el.querySelector('.address-fields') as HTMLFieldSetElement,
                el.querySelector('.same-as-shipping') as HTMLElement,
                el.querySelector('.billing-same-as-shipping') as HTMLInputElement,
                el.querySelector('.billing-full-name') as HTMLInputElement,
                el.querySelector('.billing-company') as HTMLInputElement,
                el.querySelector('.billing-phone') as HTMLInputElement,
                el.querySelector('.billing-email') as HTMLInputElement,
                el.querySelector('.billing-address-line-1') as HTMLInputElement,
                el.querySelector('.billing-address-line-2') as HTMLInputElement,
                el.querySelector('.billing-city') as HTMLInputElement,
                el.querySelector('.billing-state') as HTMLSelectElement,
                el.querySelector('.billing-zip') as HTMLInputElement,
                el.querySelector('.billing-country') as HTMLSelectElement,
                el.querySelector('.billing-payment-option-type-parent') as HTMLElement,
                el.querySelector('.billing-payment-option-type') as HTMLSelectElement,
                el.querySelector('.fields-cc') as HTMLFieldSetElement,
                el.querySelector('.fields-bank') as HTMLFieldSetElement,
                el.querySelector('.billing-credit-card-number') as HTMLInputElement,
                el.querySelector('.billing-credit-card-month') as HTMLSelectElement,
                el.querySelector('.billing-credit-card-year') as HTMLSelectElement,
                el.querySelector('.billing-credit-card-security') as HTMLInputElement,
                el.querySelector('.billing-account-number') as HTMLInputElement,
                el.querySelector('.billing-routing-number') as HTMLInputElement,
                el.querySelector('.billing-account-type-checking') as HTMLInputElement,
                el.querySelector('.billing-account-type-savings') as HTMLInputElement,
                el.querySelector('.billing-bank-type-personal') as HTMLInputElement,
                el.querySelector('.billing-bank-type-business') as HTMLInputElement,
            );

            paymentOptionFields.PaymentOptionType.addEventListener('change', () => {
                if (newOrderPayment.orderPayment.paymentOption) {
                    newOrderPayment.orderPayment.paymentOption.paymentOptionTypeID = parseInt(paymentOptionFields.PaymentOptionType.value, 10) as models.PaymentOptionTypeID;
                }
                if (!CanAmount(newOrderPayment.orderPayment.paymentOption?.paymentOptionTypeID)) {
                    newOrderPayment.paymentAmountContainer?.classList.add('d-none');
                    if (newOrderPayment.paymentAmount) {
                        newOrderPayment.paymentAmount.disabled = true;
                    }
                } else if (CanAmount(newOrderPayment.orderPayment.paymentOption?.paymentOptionTypeID) && orderPayments.length === 1) {
                    newOrderPayment.paymentAmountContainer?.classList.add('d-none');
                    if (newOrderPayment.paymentAmount) {
                        newOrderPayment.paymentAmount.disabled = true;
                    }
                } else {
                    newOrderPayment.paymentAmountContainer?.classList.remove('d-none');
                    if (newOrderPayment.paymentAmount) {
                        newOrderPayment.paymentAmount.disabled = false;
                    }
                }
                drawOrderPaymentFields();
                drawCartTotals();
            });
            paymentOptionFields.FullName.addEventListener('input', () => {
                if (newOrderPayment.orderPayment.paymentOption) {
                    newOrderPayment.orderPayment.paymentOption.fullName = paymentOptionFields.FullName.value;
                }
            });
            paymentOptionFields.Company.addEventListener('input', () => {
                if (newOrderPayment.orderPayment.paymentOption) {
                    newOrderPayment.orderPayment.paymentOption.company = paymentOptionFields.Company.value;
                }
            });
            paymentOptionFields.Country.addEventListener('change', () => {
                if (newOrderPayment.orderPayment.paymentOption) {
                    newOrderPayment.orderPayment.paymentOption.countryID = parseInt(paymentOptionFields.Country.value, 10) as models.CountryID;
                }
            });
            paymentOptionFields.AddressLine1.addEventListener('input', () => {
                if (newOrderPayment.orderPayment.paymentOption) {
                    newOrderPayment.orderPayment.paymentOption.addressLine1 = paymentOptionFields.AddressLine1.value;
                }
            });
            paymentOptionFields.AddressLine2.addEventListener('input', () => {
                if (newOrderPayment.orderPayment.paymentOption) {
                    newOrderPayment.orderPayment.paymentOption.addressLine2 = paymentOptionFields.AddressLine2.value;
                }
            });
            paymentOptionFields.City.addEventListener('input', () => {
                if (newOrderPayment.orderPayment.paymentOption) {
                    newOrderPayment.orderPayment.paymentOption.city = paymentOptionFields.City.value;
                }
            });
            paymentOptionFields.State.addEventListener('change', () => {
                if (newOrderPayment.orderPayment.paymentOption) {
                    newOrderPayment.orderPayment.paymentOption.stateID = parseInt(paymentOptionFields.State.value, 10) as models.StateID;
                }
            });
            paymentOptionFields.Zip.addEventListener('input', () => {
                if (newOrderPayment.orderPayment.paymentOption) {
                    newOrderPayment.orderPayment.paymentOption.zip = paymentOptionFields.Zip.value;
                }
            });
            paymentOptionFields.PhoneEl.addEventListener('input', async () => {
                if (newOrderPayment.orderPayment.paymentOption) {
                    newOrderPayment.orderPayment.paymentOption.phone = await paymentOptionFields.Phone.Iti.promise.then(() => paymentOptionFields.Phone.Format());
                }
            });
            paymentOptionFields.Email.addEventListener('input', () => {
                if (newOrderPayment.orderPayment.paymentOption) {
                    newOrderPayment.orderPayment.paymentOption.email = paymentOptionFields.Email.value;
                }
            });

            [
                paymentOptionFields.FullName,
                paymentOptionFields.Company,
                paymentOptionFields.AddressLine1,
                paymentOptionFields.AddressLine2,
                paymentOptionFields.City,
                paymentOptionFields.Zip,
                paymentOptionFields.PhoneEl,
                paymentOptionFields.Email,
                paymentOptionFields.Card,
                paymentOptionFields.Security,
                paymentOptionFields.AccountNumber,
                paymentOptionFields.RoutingNumber,
            ].forEach(el => el.addEventListener('input', () => delete newOrderPayment.orderPayment.paymentOption?.id));

            [
                paymentOptionFields.PaymentOptionType,
                paymentOptionFields.Country,
                paymentOptionFields.State,
                paymentOptionFields.Month,
                paymentOptionFields.Year,
            ].forEach(el => el.addEventListener('change', () => delete newOrderPayment.orderPayment.paymentOption?.id));

            [
                paymentOptionFields.BankChecking,
                paymentOptionFields.BankSavings,
                paymentOptionFields.BankPersonal,
                paymentOptionFields.BankBusiness,
            ].forEach(el => el.addEventListener('click', () => delete newOrderPayment.orderPayment.paymentOption?.id));

            paymentOptionFields.Country.addEventListener('change', () => updateCountryAndState(newOrderPayment.orderPayment.paymentOption ?? {}));
            paymentOptionFields.State.addEventListener('change', () => updateCountryAndState(newOrderPayment.orderPayment.paymentOption ?? {}));
            await updateCountryAndState(newOrderPayment.orderPayment.paymentOption ?? {});

            if (newOrderPayment.orderPayment.paymentOption) {
                newOrderPayment.orderPayment.paymentOption.paymentOptionTypeID = parseInt(paymentOptionFields.PaymentOptionType.value, 10) as models.PaymentOptionTypeID;
            }

            const paymentOptionPhoneInput = new phone.Phone(paymentOptionFields.PhoneEl);

            newOrderPayment.createPaymentOption = async () => {
                const paymentOption = {
                    fullName: paymentOptionFields.SameAsShipping.checked ? shippingOption.fullName : newOrderPayment.orderPayment.paymentOption?.fullName,
                    company: paymentOptionFields.SameAsShipping.checked ? shippingOption.company : newOrderPayment.orderPayment.paymentOption?.company,
                    country: paymentOptionFields.SameAsShipping.checked ? shippingOption.country : newOrderPayment.orderPayment.paymentOption?.country,
                    countryID: paymentOptionFields.SameAsShipping.checked ? shippingOption.countryID : newOrderPayment.orderPayment.paymentOption?.countryID,
                    addressLine1: paymentOptionFields.SameAsShipping.checked ? shippingOption.addressLine1 : newOrderPayment.orderPayment.paymentOption?.addressLine1,
                    addressLine2: paymentOptionFields.SameAsShipping.checked ? shippingOption.addressLine2 : newOrderPayment.orderPayment.paymentOption?.addressLine2,
                    city: paymentOptionFields.SameAsShipping.checked ? shippingOption.city : newOrderPayment.orderPayment.paymentOption?.city,
                    state: paymentOptionFields.SameAsShipping.checked ? shippingOption.state : newOrderPayment.orderPayment.paymentOption?.state,
                    stateID: paymentOptionFields.SameAsShipping.checked ? shippingOption.stateID : newOrderPayment.orderPayment.paymentOption?.stateID,
                    phone: paymentOptionFields.SameAsShipping.checked ? await shippingPhone.Format() : await paymentOptionPhoneInput.Format(),
                    zip: paymentOptionFields.SameAsShipping.checked ? shippingOption.zip : newOrderPayment.orderPayment.paymentOption?.zip,
                    email: paymentOptionFields.SameAsShipping.checked ? shippingOption.email : newOrderPayment.orderPayment.paymentOption?.email,

                    paymentOptionTypeID: newOrderPayment.orderPayment.paymentOption?.paymentOptionTypeID,
                };
                await updateCountryAndState(paymentOption);

                return paymentoptions.NewPaymentOption({
                    user: userDetails(),
                    paymentOption,
                    creditCardNumber: paymentOptionFields.Card.value,
                    expireMonth: parseInt(paymentOptionFields.Month.value, 10),
                    expireYear: parseInt(paymentOptionFields.Year.value, 10),
                    securityCode: paymentOptionFields.Security.value,
                    bankAccount: paymentOptionFields.AccountNumber.value,
                    bankRouting: paymentOptionFields.RoutingNumber.value,
                    accountType: paymentOptionFields.BankChecking.checked ? 'checking' : 'savings',
                    bankType: paymentOptionFields.BankPersonal.checked ? 'personal' : 'business',
                    fattmerchantOmniWebPaymentsToken: window.staxOmniWebPaymentsToken,
                });
            };
        }

        const drawOrderPaymentFields = () => {
            orderPaymentFields.innerHTML = '';

            delete newOrderPayment.orderPayment.purchaseOrderNumber;
            delete newOrderPayment.poNumberEl;
            delete newOrderPayment.poUploader;

            paymentFieldsContainer.classList.add('d-none');

            const el = payments.DrawOrderPaymentFields(newOrderPayment.orderPayment.paymentOption ?? {});
            if (!el) {
                return;
            }

            let show: boolean = false;

            switch (newOrderPayment.orderPayment.paymentOption?.paymentOptionTypeID) {
            case models.PaymentOptionTypeID.PAYMENT_OPTION_TYPE_PO: {
                newOrderPayment.poNumberEl = el.querySelector('.po-number') as HTMLInputElement;
                const uploader = el.querySelector('.uploads') as HTMLLabelElement;
                const thumbnails = el.querySelector('.uploads-thumbnails') as HTMLElement;

                newOrderPayment.poNumberEl.addEventListener('input', () => newOrderPayment.orderPayment.purchaseOrderNumber = newOrderPayment.poNumberEl?.value);

                newOrderPayment.poUploader = new uploads.Uploader(uploader, {
                    thumbnails,
                    thumbnailMaxHeight: '100px',
                });

                show = true;
                break;
            }
            default:
                break;
            }

            if (!newOrderPayment.orderPayment.paymentOption?.id && !show) {
                return;
            }

            orderPaymentFields.appendChild(el);
            paymentFieldsContainer.classList.remove('d-none');
        };
        drawOrderPaymentFields();

        const paymentSuccess = el.querySelector('.payment-success') as HTMLElement;
        const paymentError = el.querySelector('.payment-error') as HTMLElement;
        const paymentErrorText = paymentError.querySelector('.alert-text') as HTMLElement;

        newOrderPayment.createOrderPayment = async (orderID: string) => {
            if (orderPayments.length > 1) {
                spinner.classList.remove('d-none');
            }

            const orderPaymentReq: Record<string, unknown> = {
                'user': userDetails(),
                'orderIDs': [orderID],
                'paymentOptionID': newOrderPayment.orderPayment.paymentOption?.key || newOrderPayment.orderPayment.paymentOption?.id,
                'amount': orderPayments.length > 1 ? newOrderPayment.orderPayment.total : undefined,
            };

            switch (newOrderPayment.orderPayment.paymentOption?.paymentOptionTypeID) {
            case models.PaymentOptionTypeID.PAYMENT_OPTION_TYPE_PO:
                orderPaymentReq['poNumber'] = newOrderPayment.poNumberEl?.value;
                orderPaymentReq['poUploadIDs'] = newOrderPayment.poUploader?.GetUploadIDs();
                break;
            default:
                break;
            }

            paymentError.classList.add('d-none');

            return axios.post<models.OrderPayment[]>('/order-payments', orderPaymentReq).
                then(() => {
                    newOrderPayment.charged = true;
                    edit.classList.add('d-none');
                    el.disabled = true;
                    if (orderPayments.length > 1) {
                        paymentSuccess.classList.remove('d-none');
                    }
                }).catch(err => {
                    let text = String(err);
                    const paramErrors = errors.GetAxiosParamErrors(err);
                    if (AxiosStatusCode(err) === 400 && paramErrors) {
                        for (const e of paramErrors.errors) {
                            switch (e.code) {
                            case 'declined':
                                text = `Payment declined: ${e.message}`;
                                if (e.message.includes('charged in succession')) {
                                    if (!edit.classList.contains('d-none')) {
                                        text = 'Our merchant only lets us charge a payment method a certain amount of times. Please re-enter your payment details, or try a different payment method.';
                                    } else {
                                        text = 'Something went wrong trying to process your payment, please try submitting again.';
                                        delete newOrderPayment.orderPayment.paymentOption?.id;
                                    }
                                }
                                break;
                            case 'invalid':
                                text = 'Your credit card on file isn\'t valid. Reasons include expired card, or possibly we changed payment processors since this was added. Please re-enter your credit card details, or try a different payment method.';
                                break;
                            default:
                                break;
                            }
                        }
                    }

                    sidebarFieldset.removeAttribute('disabled');

                    paymentError.classList.remove('d-none');
                    paymentErrorText.textContent = text;

                    console.error(err);
                }).finally(() => spinner.classList.add('d-none'));
        };

        billingSpinner.parentElement?.removeChild(billingSpinner);
        billingCard.insertBefore(el, billingFooter);
        orderPayments.push(newOrderPayment);

        if (orderPayments.length > 1) {
            for (const orderPayment of orderPayments) {
                if (!CanAmount(orderPayment.orderPayment.paymentOption?.paymentOptionTypeID)) {
                    orderPayment.paymentAmountContainer?.classList.add('d-none');
                    if (orderPayment.paymentAmount) {
                        orderPayment.paymentAmount.disabled = true;
                        continue;
                    }
                }
                orderPayment.paymentAmountContainer?.classList.remove('d-none');
                if (orderPayment.paymentAmount) {
                    orderPayment.paymentAmount.disabled = false;
                }
            }
        }

        return newOrderPayment;
    };

    let sess: Promise<session.SessionResp> | undefined;
    let previousPaymentOption: Promise<models.PaymentOption | undefined> | undefined;
    let balancePaymentOption: Promise<models.PaymentOption | undefined> | undefined;
    const loadPreviousPaymentOption: (id?: string) => Promise<models.PaymentOption | undefined> = id => paymentoptions.GetPaymentOptions({
        'data': 'fullName,company,addressLine1,addressLine2,city,stateID,zip,countryID,phone,email,creditCardFirst6,creditCardLast4,creditCardExpirationDate,key,paymentOptionTypeID',
        'sort': 'lastOrdered desc,created desc',
        'size': 1,
        'q': `${id ? ` id:${id}` : 'valid:yes'} has:email has:phone has:fullName has:addressLine1 has:city has:countryID has:zip`,
    }).then(async paymentOptions => {
        if (paymentOptions.length) {
            return paymentOptions[0];
        }

        if (id) {
            return loadPreviousPaymentOption();
        }

        return;
    });

    let balanceOrderPayment: newOrderPayment | undefined;
    let defaultOrderPayment: newOrderPayment | undefined;

    const updateUnmodifiedPaymentAmounts = async () => {
        if (paymentsEditedByUser) {
            return;
        }

        const sessSync = await sess;
        const previousPaymentOptionSync = await previousPaymentOption;
        const balancePaymentOptionSync = await balancePaymentOption;

        if (!total.gt('0')) {
            // eslint-disable-next-line no-console
            console.log('yay! its free!!');
            return;
        }

        const balance = new Big(sessSync?.balance || '0');
        const appliedBalance = total.lt(balance) ? total : balance;
        const appliedBalanceStr = appliedBalance.toString();

        const remaining = total.sub(appliedBalance);
        const remainingStr = remaining.toString();

        if (balance.gt('0')) {
            if (!balanceOrderPayment) {
                balanceOrderPayment = await newEmptyOrderPayment(balancePaymentOptionSync);
            }

            balanceOrderPayment.orderPayment.total = appliedBalanceStr;
            if (balanceOrderPayment.paymentAmount) {
                balanceOrderPayment.paymentAmount.value = appliedBalanceStr;
                balanceOrderPayment.paymentAmount.max = appliedBalanceStr;
            }
        } else if (balanceOrderPayment) {
            await deleteOrderPayment(balanceOrderPayment);
            balanceOrderPayment = undefined;
        }

        if (remaining.gt('0')) {
            if (!defaultOrderPayment) {
                defaultOrderPayment = await newEmptyOrderPayment(previousPaymentOptionSync);
            }

            defaultOrderPayment.orderPayment.total = remainingStr;
            if (defaultOrderPayment.paymentAmount) {
                defaultOrderPayment.paymentAmount.value = remainingStr;
            }
        } else if (defaultOrderPayment) {
            await deleteOrderPayment(defaultOrderPayment);
            defaultOrderPayment = undefined;
        }

        drawCartTotals();
    };

    if (session.GetLoginToken()) {
        sess = session.Session();
        previousPaymentOption = loadPreviousPaymentOption(window.sessionStorage.getItem('paymentOptionID') || undefined);
        balancePaymentOption = new Promise(resolve =>
            sess?.then(sess => {
                if (Big(sess.balance)) {
                    resolve(payments.GetBalancePaymentOption());
                } else {
                    resolve(undefined);
                }
            }),
        );
    }

    splitPayment.addEventListener('click', () => {
        if (session.GetLoginToken()) {
            void payments.PromptPaymentOption(userDetails(), undefined, undefined, true).then(paymentOption => newEmptyOrderPayment(paymentOption));
        } else {
            void newEmptyOrderPayment();
        }
    });

    let subtotal: Big = Big(0);
    let discount: Big = Big(0);
    let shipping: Big = Big(0);
    let taxAmount: Big = Big(0);
    let taxRate: Big = Big(0);
    let total: Big = Big(0);

    const shippingCountryReady = countries.Selects(shippingCountry, shippingState, {
        defaultUnitedStates: true,
        stateParentSelector: 'div',
        phone: shippingPhone,
        onStateHide: () => {
            shippingState.disabled = true;
            shippingZip.parentElement?.classList.replace('col-md-2', 'col-md-6');
        },
        onStateShow: () => {
            shippingState.disabled = false;
            shippingZip.parentElement?.classList.replace('col-md-6', 'col-md-2');
        },
    }).finally(() => {
        shippingCountry.addEventListener('change', async () => {
            shippingOption.countryID = parseInt(shippingCountry.value, 10) as models.CountryID;
            delete shippingOption.state;
            delete shippingOption.stateID;

            if (shippingOption.countryID && shippingOption.countryID !== models.CountryID.COUNTRIES_UNITED_STATES) {
                shippingCountry.parentElement?.parentElement?.insertBefore(nonUsAlert, shippingAddressLine1.parentElement);
                nonUsAlert.classList.remove('d-none');
            } else {
                nonUsAlert.classList.add('d-none');
            }

            await updateCountryAndState(shippingOption);
            updateCartAddress();
            updateTaxExemptionVisibility();
            checkTaxState();
        });

        [shippingState, shippingCountry].forEach(el => el.addEventListener('change', () => {
            delete shippingOption.id;
            updateCartAddress();
            drawCartTotals();
            checkTaxState();
            delete shippingOption.id;
        }));
    });

    shippingFullName.addEventListener('input', () => shippingOption.fullName = shippingFullName.value);
    shippingCompany.addEventListener('input', () => shippingOption.company = shippingCompany.value);
    shippingAddressLine1.addEventListener('input', () => shippingOption.addressLine1 = shippingAddressLine1.value);
    shippingAddressLine2.addEventListener('input', () => shippingOption.addressLine2 = shippingAddressLine2.value);
    shippingCity.addEventListener('input', () => shippingOption.city = shippingCity.value);
    shippingZip.addEventListener('input', () => shippingOption.zip = shippingZip.value);
    shippingPhoneEl.addEventListener('input', async () => shippingOption.phone = await shippingPhone.Iti.promise.then(() => shippingPhone.Format()));
    shippingEmail.addEventListener('input', () => shippingOption.email = shippingEmail.value);

    CheckPOBoxNewAddress(shippingCountry, shippingState, shippingAddressLine1, shippingForm);

    shippingZip.setAttribute('data-api', 'shipping.zip');

    shippingState.addEventListener('change', async () => {
        shippingOption.stateID = parseInt(shippingState.value, 10) as models.StateID;

        await updateCountryAndState(shippingOption);
        checkTaxState();
    });

    [
        shippingFullName,
        shippingCompany,
        shippingPhoneEl,
        shippingEmail,
    ].forEach(el => el.addEventListener('input', () => {
        delete shippingOption.id;
    }));

    [
        shippingAddressLine1,
        shippingAddressLine2,
        shippingCity,
        shippingZip,
    ].forEach(el => el.addEventListener('input', () => {
        updateCartAddress();
        delete shippingOption.id;
    }));

    void countries.Selects(userTaxCountry, userTaxState, {
        defaultUnitedStates: true,
    });

    userTaxState.addEventListener('change', async () => {
        if (!userTaxExemption) {
            return;
        }

        userTaxExemption.stateID = parseInt(userTaxState.value, 10) as models.StateID;

        await updateCountryAndState(userTaxExemption);
        updateCartTotals();
        drawCartTotals();
        checkTaxState();
    });

    const userTaxExemptionEls = [userTaxExemptNumber, userTaxCountry, userTaxState];

    const reason = userTaxExemptionForm.querySelector('#user-tax-exemption-reason') as HTMLSelectElement;
    reason.addEventListener('change', async () => {
        const reasonID = (parseInt(reason.value, 10) || undefined) as models.UserTaxExemptionReasonID | undefined;
        if (reasonID) {
            userTaxExemptionAdditionalFields.classList.remove('d-none');
            userTaxExemptionAdditionalFields.disabled = false;
            userTaxExemptionEls.forEach(el => el.required = true);
            userTaxExemption = {
                userTaxExemptionReasonID: reasonID,
                stateID: parseInt(userTaxState.value, 10) as models.StateID,
            };
        } else {
            userTaxExemptionAdditionalFields.classList.add('d-none');
            userTaxExemptionAdditionalFields.disabled = true;
            userTaxExemptionEls.forEach(el => el.required = false);
            userTaxExemption = undefined;
        }
        updateCartTotals();
        await updateUnmodifiedPaymentAmounts();
        drawCartTotals();
        checkTaxState();
    });

    userTaxExemptNumber.addEventListener('input', () => {
        if (!userTaxExemption) {
            return;
        }

        userTaxExemption.number = userTaxExemptNumber.value;
        delete userTaxExemption.id;
    });

    [reason, userTaxState].forEach(el => el.addEventListener('change', async () => {
        if (userTaxExemption) {
            delete userTaxExemption.id;
            await updateCountryAndState(userTaxExemption);
        }
        updateCartTotals();
        drawCartTotals();
        updateCartDebounce();
        checkTaxState();
    }));

    const userTaxExemptionUploads = new uploads.Uploader(userTaxUpload, {
        thumbnails: userTaxThumbnails,
        thumbnailMaxHeight: '100px',
        onchange: () => delete userTaxExemption?.id,
    });

    const drawShippingAddress = async () => {
        shippingAddress.innerHTML = '';
        shippingAddress.classList.remove('d-none');
        const drawEl = await shippingoptions.Draw(shippingOption);
        if (shippingOption.countryID && shippingOption.stateID && shippingOption.addressLine1 && shippingAddress) {
            void CheckPOBoxAddress((shippingOption.countryID as models.CountryID) ?? models.CountryID.COUNTRIES_UNITED_STATES, shippingOption.stateID, shippingOption.addressLine1, shippingAddress);
        }
        shippingAddress.appendChild(drawEl);
        if (shippingOption.countryID && shippingOption.countryID !== models.CountryID.COUNTRIES_UNITED_STATES) {
            const addressSpan = document.querySelector('.address-lines') as HTMLElement;
            addressSpan.nextElementSibling?.remove();
            addressSpan.append(nonUsAlert);
            nonUsAlert.classList.add('mt-2');
            nonUsAlert.classList.remove('d-none');
        } else {
            nonUsAlert.classList.add('d-none');
        }
    };

    const updateTaxExemptionVisibility = () => {
        if (shippingOption?.countryID === models.CountryID.COUNTRIES_UNITED_STATES) {
            userTaxExemptionCard.classList.remove('d-none');
            userTaxExemptionFieldset.disabled = false;
        } else {
            userTaxExemptionCard.classList.add('d-none');
            userTaxExemptionFieldset.disabled = true;
        }
        checkTaxState();
    };

    const useShippingOption = async (newShippingOption: models.ShippingOption) => {
        shippingOption = newShippingOption;
        window.sessionStorage.setItem('shippingOptionID', shippingOption.id || '');
        await updateCountryAndState(shippingOption);
        await drawShippingAddress();
        updateCartAddress();
        updateTaxExemptionVisibility();
        checkTaxState();
    };

    const updateCartDebounce = Debounce(async () => {
        let taxAddress: smgCarts.TaxAddress | undefined;
        if (
            shippingOption?.countryID &&
            shippingOption.addressLine1 &&
            shippingOption.city &&
            (shippingOption.stateID || !(await countries.GetCountry(shippingOption.countryID))?.states?.length) &&
            shippingOption.zip && (shippingOption.zip.trim().length >= 5 || shippingOption.countryID !== models.CountryID.COUNTRIES_UNITED_STATES)
        ) {
            taxAddress = {
                addressLine1: shippingOption.addressLine1,
                addressLine2: shippingOption.addressLine2,
                city: shippingOption.city,
                countryID: shippingOption.countryID,
                stateID: shippingOption.stateID,
                zip: shippingOption.zip,
            };
        }

        smgCarts.GetCart(taxAddress, promoCode?.code).then(cart => {
            discount = Big(cart?.discount ?? 0);
            shipping = Big(cart?.shipping ?? 0);
            taxAmount = Big(cart?.taxAmount ?? 0);
            taxRate = Big(cart?.taxRate ?? 0);
        }).catch(err => {
            taxAmount = Big(0);
            taxRate = Big(0);

            errors.HandleRequestError(err, form, undefined, { 'zip': 'shipping.zip' });
        }).finally(async () => {
            updateCartTotals();
            await updateUnmodifiedPaymentAmounts();
            drawCartTotals();
            cartTaxSpinners.forEach(el => el.classList.add('d-none'));
            cartShippingSpinners.forEach(el => el.classList.add('d-none'));
        });
    }, 500, false);

    const updateCartAddress = () => {
        cartTaxSpinners.forEach(el => el.classList.remove('d-none'));
        cartShippingSpinners.forEach(el => el.classList.remove('d-none'));
        updateCartDebounce();
    };

    const drawUserTaxExemption = async () => {
        if (userTaxExemption) {
            userTaxExemptionEl.innerHTML = '';
            userTaxExemptionEl.classList.remove('d-none');
            userTaxExemptionEl.appendChild(await usertaxexemptions.Draw(userTaxExemption));
        } else {
            userTaxExemptionEl.textContent = 'No Tax Exemption';
        }
    };

    const useUserTaxExemption = async (newUserTaxExemption: models.UserTaxExemption | undefined) => {
        userTaxExemption = newUserTaxExemption;
        if (newUserTaxExemption) {
            window.sessionStorage.setItem('userTaxExemptionID', userTaxExemption?.id || '');
        } else {
            window.sessionStorage.removeItem('userTaxExemptionID');
        }
        drawCartTotals();
        updateCartDebounce();
        await drawUserTaxExemption();
        updateCartTotals();
        checkTaxState();
    };

    const effectiveTaxRate = (): { taxAmount: Big; taxRate: Big } => {
        if (userTaxExemption && (!userTaxExemption.stateID || userTaxExemption.stateID === shippingOption.stateID)) {
            return { taxAmount: Big('0'), taxRate: Big('0') };
        }
        return { taxAmount, taxRate };
    };

    const updateCartTotals = () => {
        const { taxAmount } = effectiveTaxRate();
        total = subtotal.add(discount).add(shipping).add(taxAmount);
    };

    const drawCartTotals = () => {
        cartSubtotalEls.forEach(el => el.textContent = DollarFormat(subtotal));
        cartDiscountEls.forEach(el => el.textContent = DollarFormat(discount));
        cartShippingEls.forEach(el => el.textContent = DollarFormat(shipping));

        const { taxAmount, taxRate } = effectiveTaxRate();

        cartTaxEls.forEach(el => el.textContent = DollarFormat(taxAmount));

        if (!taxRate.eq(0)) {
            cartTaxRateParents.forEach(el => el.classList.remove('d-none'));
            cartTaxRateEl.forEach(el => el.textContent = String(taxRate.mul('100')));
        } else {
            cartTaxRateParents.forEach(el => el.classList.add('d-none'));
        }

        cartTotalEls.forEach(el => el.textContent = DollarFormat(total));

        const t = paymentTotal();
        cartPayment.forEach(el => el.textContent = DollarFormat(t));

        let onlyPO = false;
        for (const newOrderPayment of orderPayments) {
            if (newOrderPayment.orderPayment.paymentOption?.paymentOptionTypeID !== models.PaymentOptionTypeID.PAYMENT_OPTION_TYPE_PO) {
                onlyPO = false;
                break;
            } else {
                onlyPO = true;
            }
        }

        if (!total || t.gte(total) || onlyPO || !orderPayments.length) {
            cartPaymentContainer.classList.remove('alert', 'alert-warning');
            cartPaymentWarnIcon.classList.add('d-none');
            nonPaymentWarning.classList.add('d-none');
        } else {
            cartPaymentContainer.classList.add('alert', 'alert-warning');
            cartPaymentWarnIcon.classList.remove('d-none');
            nonPaymentWarning.classList.remove('d-none');
        }
    };

    const checkTaxState = () => {
        if (!userTaxExemption || userTaxExemption?.stateID === shippingOption.stateID || !userTaxExemption.stateID) {
            document.querySelector('#unapplicable-tax-warning')?.classList.add('d-none');
        } else {
            document.querySelector('#unapplicable-tax-warning')?.classList.remove('d-none');
            updateCartTotals();
        }
    };

    const userDetails = (): UserDetails => ({
        fullName: shippingOption.fullName || '',
        company: shippingOption.company || '',
        email: shippingOption.email || '',
        phone: shippingOption.phone || '',
        countryID: shippingOption.countryID,
        stateID: shippingOption.stateID,
    });

    // don't really want this to submit easily, make them use the big button
    form.noValidate = true;
    form.addEventListener('submit', e => {
        e.preventDefault();
        if (!ReportValidity(form)) {
            return false;
        }
    });

    const showLoading = () => {
        fieldset.disabled = true;
        buttons.Start(placeOrder);
        fieldset.querySelectorAll('a').forEach(el => el.setAttribute('disabled', 'disabled'));
    };

    const hideLoading = () => {
        fieldset.disabled = false;
        buttons.Stop(placeOrder);
        fieldset.querySelectorAll('a').forEach(el => el.removeAttribute('disabled'));
    };

    let orderID: string;
    let key: string;

    placeOrder.addEventListener('click', async () => {
        const products: string[] = [];
        const productNodes = document.querySelectorAll('.cart-item-summary') as NodeListOf<Element>;
        const productArr = Array.from(productNodes);
        for (const product of productArr) {
            products.push(product.innerHTML);
        }
        // const productStr = products.join(' , ').toString();

        // if (!paypalCheckbox.checked) {
        for (const newOrderPayment of orderPayments) {
            switch (newOrderPayment.orderPayment.paymentOption?.paymentOptionTypeID) {
            case models.PaymentOptionTypeID.PAYMENT_OPTION_TYPE_PO:
                newOrderPayment.poNumberEl?.setCustomValidity('');
                if (newOrderPayment.poNumberEl?.value && !newOrderPayment.poUploader?.GetUploadIDs().length) {
                    newOrderPayment.poNumberEl?.setCustomValidity('Please attach a copy of your purchase order document(s)');
                }
                break;
            default:
                break;
            }
        }
        // }

        if (shippingOption.countryID === models.CountryID.COUNTRIES_UNITED_STATES && (shippingOption.zip || '').trim().length < 5) {
            shippingZip.setCustomValidity('A valid zip code is required');
            const clearZipError = () => {
                shippingZip.setCustomValidity('');
                shippingZip.removeEventListener('input', clearZipError);
            };
            shippingZip.addEventListener('input', clearZipError);
        }

        if (!ReportValidity(form)) {
            return false;
        }

        const createShippingOption = async () => shippingoptions.New(userDetails(), {
            fullName: shippingOption.fullName,
            company: shippingOption.company,
            country: shippingOption.country,
            addressLine1: shippingOption.addressLine1,
            addressLine2: shippingOption.addressLine2,
            city: shippingOption.city,
            state: shippingOption.state,
            zip: shippingOption.zip,
            phone: await shippingPhone.Format(),
            email: shippingOption.email,
        });

        const createUserTaxExemption = async () => usertaxexemptions.New({
            user: userDetails(),
            number: userTaxExemption?.number || '',
            countryID: parseInt(userTaxCountry.value, 10),
            stateID: parseInt(userTaxState.value, 10) || undefined,
            uploadIDs: userTaxExemptionUploads.GetUploadIDs(),
            userTaxExemptReasonID: userTaxExemption?.userTaxExemptionReasonID || 0,
        });
        // let gtmTransactionId: string = '';
        const createOrder = async () => axios.post<createOrderResp>('/orders', {
            'user': userDetails(),
            'cartID': smgCarts.GetCartID(),
            'shippingOptionIDs': [shippingOption.id],
            'userTaxExemptionID': userTaxExemption?.id,
            'sms': sms.checked,
            'promotionalApproval': caseStudy.checked,
        }).then(resp =>
            // gtmTransactionId = resp.data.invoiceNumber.toString();
            resp.data,
        );

        showLoading();

        try {
            if (!shippingOption.id) {
                shippingOption = await createShippingOption();
                await updateCountryAndState(shippingOption);
            }

            if (userTaxExemption && !userTaxExemption.id) {
                userTaxExemption = await createUserTaxExemption();
            }

            let declines = false;

            // if (!paypalCheckbox.checked) {
            const paymentOptionCreatePromises: Promise<models.PaymentOption>[] = [];
            for (const newOrderPayment of orderPayments) {
                if (newOrderPayment.orderPayment.paymentOption?.id) {
                    continue;
                }

                if (newOrderPayment.createPaymentOption) {
                    const p = newOrderPayment.createPaymentOption().catch(err => {
                        if (AxiosStatusCode(err) === 422 &&
                            object.IsObject(err) &&
                            object.HasKey(err, 'response') &&
                            object.IsObject(err['response']) &&
                            object.IsObject(err['response']['data']) &&
                            err['response']['data']['errors'] instanceof Array) {
                            const paramErrors: errors.ParamErrors = { errors: [] };
                            for (const e of err['response']['data']['errors']) {
                                if (object.IsObject(e) && object.HasKey(e, 'message')) {
                                    switch (e['attribute']) {
                                    case 'card_type':
                                    case 'number':
                                        paramErrors.errors.push({
                                            message: e['message'] as string,
                                            param: e['attribute'],
                                        });
                                        break;
                                    default:
                                        throw new Error(err['response']['data']['errors'].map(e => {
                                            if (object.IsObject(e)) {
                                                return e['message'];
                                            }
                                        }).filter(Boolean).join(', '));
                                    }
                                }
                            }
                            throw paramErrors;
                        }
                        throw new errors.SMGError(String(err), { scope: 'billing' });
                    });
                    await p.then(newPaymentOption => newOrderPayment.orderPayment.paymentOption = newPaymentOption);
                    paymentOptionCreatePromises.push(p);
                }
            }
            await Promise.all(paymentOptionCreatePromises);
            // }

            let orderCreated = false;
            if (!orderID) {
                const resp = await createOrder();
                orderID = resp.orderID;
                // invoiceNumber = resp.invoiceNumber;
                key = resp.key;

                orderCreated = true;

                shippingFieldset.disabled = true;
                shippingEdit.classList.add('d-none');

                userTaxExemptionFieldset.disabled = true;
                userTaxExemptionEdit.classList.add('d-none');

                sidebarFieldset.disabled = true;
            }

            // if (!paypalCheckbox.checked) {
            for (const newOrderPayment of orderPayments) {
                if (newOrderPayment.charged) {
                    continue;
                }
                if (newOrderPayment.createOrderPayment) {
                    await newOrderPayment.createOrderPayment(orderID);
                }
            }
            for (const newOrderPayment of orderPayments) {
                if (!newOrderPayment.charged) {
                    declines = true;
                    break;
                }
            }

            if (orderCreated) {
                await axios.post(`/orders/${orderID}/workflows/placed`);
            }

            if (!declines) {
                await smgCarts.DeleteCart();
                window.location.href = `${Relref('/order-submitted')}?id=${key}`;
            } else {
                hideLoading();
            }
        } catch (err) {
            hideLoading();

            errors.HandleRequestError(err, form);
        }
    });

    let shippingOptionsReady: Promise<void> | undefined;

    // check if the user is possibly logged in
    if (session.GetLoginToken()) {
        const getShippingOption = async (id?: string): Promise<models.ShippingOption[]> => shippingoptions.Get({
            'data': 'fullName,company,addressLine1,addressLine2,city,stateID,zip,countryID,phone,email',
            'sort': 'lastOrdered desc,created desc',
            'size': '1',
            'q': `${id ? `id:${id}` : ''} has:email has:phone has:fullName has:addressLine1 has:city has:countryID has:zip`,
        }).then(shippingOptions => {
            if (id) {
                if (shippingOptions.length) {
                    return shippingOptions;
                }
                return getShippingOption();
            }
            return shippingOptions;
        });
        shippingOptionsReady = getShippingOption(window.sessionStorage.getItem('shippingOptionID') || undefined).then(async shippingOptions => {
            if (shippingOptions.length) {
                await useShippingOption(shippingOptions[0]);
                shippingEdit.classList.remove('d-none');
                shippingForm.parentElement?.removeChild(shippingForm);

                // fix for shipping address loaded, no billing address, same as shipping
                shippingPhoneEl.value = shippingOption.phone || '';
            } else {
                window.sessionStorage.removeItem('shippingOptionID');
                shippingForm.classList.remove('d-none');
            }
        }).finally(() => shippingSpinner.parentElement?.removeChild(shippingSpinner));

        shippingEdit.addEventListener('click', async e => {
            e.preventDefault();
            await shippingoptions.Prompt(userDetails()).then(newShippingOption => useShippingOption(newShippingOption));
        });

        const getUserTaxExemption = async (id?: string): Promise<models.UserTaxExemption[]> => usertaxexemptions.Get({
            'data': 'number,countryID,stateID,userTaxExemptionUploads,userTaxExemptionReasonID,userTaxExemptionReason',
            'sort': 'lastOrdered desc,created desc',
            'size': '1',
            'q': id ? `id:${id}` : '',
        }).then(userTaxExemptions => {
            if (id) {
                if (userTaxExemptions.length) {
                    return userTaxExemptions;
                }
                return getUserTaxExemption();
            }
            return userTaxExemptions;
        });
        await getUserTaxExemption(window.sessionStorage.getItem('userTaxExemptionID') || undefined).then(async userTaxExemptions => {
            if (userTaxExemptions.length) {
                await useUserTaxExemption(userTaxExemptions[0]);
                userTaxExemptionEdit.classList.remove('d-none');
                userTaxExemptionForm.parentElement?.removeChild(userTaxExemptionForm);
            } else {
                window.sessionStorage.removeItem('userTaxExemptionID');
                userTaxExemptionForm.classList.remove('d-none');
            }
        }).finally(() => userTaxExemptionSpinner.parentElement?.removeChild(userTaxExemptionSpinner));

        userTaxExemptionEdit.addEventListener('click', async e => {
            e.preventDefault();
            await usertaxexemptions.Prompt({
                fullName: shippingOption.fullName || '',
                company: shippingOption.company || '',
                email: shippingOption.email || '',
                phone: shippingOption.phone || '',
            }).then(newUserTaxExemption => useUserTaxExemption(newUserTaxExemption));
        });
    } else {
        shippingForm.classList.remove('d-none');
        shippingSpinner.parentElement?.removeChild(shippingSpinner);

        userTaxExemptionForm.classList.remove('d-none');
        userTaxExemptionSpinner.parentElement?.removeChild(userTaxExemptionSpinner);
    }

    // make sure we're done checking about shipping options
    void (async () => {
        await shippingOptionsReady;
        await shippingCountryReady;

        if (shippingOption.id) {
            return;
        }

        // user not logged in or has no shipping options
        [shippingCountry, shippingState].forEach(el => el.dispatchEvent(new Event('change')));
        [shippingAddressLine1, shippingAddressLine2, shippingCity, shippingZip, shippingPhoneEl, shippingEmail].forEach(el => el.dispatchEvent(new Event('input')));
    })();

    const cartCard = document.querySelector('#cart-card') as HTMLElement;

    const spinner = document.querySelector('#cart-spinner') as HTMLElement;

    const editCart = document.querySelector('#edit-cart') as HTMLElement;

    const showEmptyCart = () => {
        window.location.href = Relref('/cart');
    };

    const drawCartItem = (cartItem: models.CartItem): HTMLElement => {
        const cartItemEl = template.Clone(cartItem.stockItem ? '.cart-item-stock-item-template' : '.cart-item-template').firstElementChild as HTMLElement;
        cartItemEl.removeAttribute('id');

        const title = cartItemEl.querySelector('.cart-item-title') as HTMLElement;

        const subtotal = cartItemEl.querySelector('.cart-item-subtotal') as HTMLElement;
        subtotal.textContent = DollarFormat(cartItem.total || 0);

        const oldSubtotal = cartItemEl.querySelector('.text-decoration-line-through') as HTMLElement;
        if (cartItem.maxNetworkSubtotal && Big(cartItem.maxNetworkSubtotal).gt(cartItem.subtotal || 0)) {
            subtotal.classList.add('text-primary');
            oldSubtotal.textContent = DollarFormat(cartItem.maxNetworkSubtotal);
        } else {
            oldSubtotal.parentElement?.removeChild(oldSubtotal);
        }

        const info = cartItemEl.querySelector<HTMLAnchorElement>('.cart-item-info');
        if (cartItem.quote?.quoteLineItems?.length || cartItem.order?.orderLineItems?.length) {
            info?.addEventListener('click', async e => {
                e.preventDefault();

                new Modal({
                    title: `Pricing breakdown for ${title.textContent || ''}`,
                    body: await lineitems.Table(cartItem.quote?.quoteLineItems || cartItem.order?.orderLineItems || []),
                    size: 'modal-lg',
                    cancelText: 'Close',
                });
            });
        } else if (info) {
            info.parentElement?.removeChild(info);
        }

        const drawCartItemLine = (lineItem: models.QuoteLineItem | models.OrderLineItem): HTMLElement => {
            const lineItemEl = template.Clone('.cart-item-line', cartItemEl).firstElementChild as HTMLElement;
            const summary = lineItemEl.querySelector('.cart-item-summary') as HTMLElement;

            const proofLink = lineItemEl.querySelector('.proof-link') as HTMLAnchorElement;
            const proofImg = proofLink.querySelector('img') as HTMLImageElement;
            const proof = (lineItem as models.QuoteLineItem).quoteProof?.proof || (lineItem as models.OrderLineItem).orderProof?.proof;
            let proofName: string = '';
            if (proof?.main) {
                proofLink.href = proof.main;
                proofLink.setAttribute('data-fancybox', `cart-item-${cartItem.id || ''}`);

                proofImg.src = proof.thumbnail || proof.main;

                if ((lineItem as models.QuoteLineItem).quoteProof?.number) {
                    proofName = `Proof ${(lineItem as models.QuoteLineItem).quoteProof?.number || ''}`;
                } else {
                    proofName = (lineItem as models.OrderLineItem).orderProof?.name || '';
                }
                proofLink.setAttribute('data-caption', proofName);

                proofImg.title = proofName;
                proofImg.alt = proofName;
            } else {
                proofLink.parentElement?.removeChild(proofLink);
            }

            summary.textContent = '';
            if (proofName) {
                if ((lineItem as models.QuoteLineItem).quoteProof?.number) {
                    summary.textContent += `Proof ${(lineItem as models.QuoteLineItem).quoteProof?.number || 1}`;
                } else {
                    summary.textContent += (lineItem as models.OrderLineItem).orderProof?.name ?? '';
                }

                summary.textContent += ' - ';
            }

            const qty = lineItem.quantity || 0;
            const product = (qty === 1 ? lineItem.lineItemModel?.name : lineItem.lineItemModel?.pluralName) || lineItem.lineItem;
            summary.textContent += `${Number(qty).toLocaleString()} ${product || ''}`;

            if (lineItem.invalidCustomQuantity) {
                lineItemEl.querySelector<HTMLElement>('.cart-item-invalid-quantity')?.classList.remove('d-none');
            }

            return lineItemEl;
        };

        const cartItemDescription = cartItemEl.querySelector('.cart-item-description') as HTMLElement;

        const proofs: models.Proof[] = [];
        const shownProofs = new Set<string>();

        let productCount = 0;
        const objectLineItems = cartItem.quote?.quoteLineItems || cartItem.order?.orderLineItems;
        if (objectLineItems) {
            for (const objectLineItem of objectLineItems) {
                if (objectLineItem.lineItemModel?.tax || objectLineItem.lineItemModel?.shipping) {
                    continue;
                }

                productCount++;

                if (productCount >= 2) {
                    break;
                }
            }
        }

        let invalidCustomQuantity = false;

        if (cartItem.quote) {
            title.textContent = `Quote ${cartItem.quote.serial || ''}`;

            if (cartItem.quote.quoteProofs) {
                for (const quoteProof of cartItem.quote.quoteProofs) {
                    if (!quoteProof.proof) {
                        continue;
                    }
                    quoteProof.proof.name = `Proof ${quoteProof.name || ''}`;
                    proofs.push(quoteProof.proof);
                }
            }

            if (cartItem.quote.quoteLineItems) {
                for (const quoteLineItem of cartItem.quote.quoteLineItems) {
                    if (quoteLineItem.lineItemModel?.tax || quoteLineItem.lineItemModel?.shipping) {
                        continue;
                    }

                    cartItemDescription.appendChild(drawCartItemLine(quoteLineItem));

                    if (quoteLineItem.quoteProof?.proof?.id) {
                        shownProofs.add(quoteLineItem.quoteProof?.proof.id);
                    }

                    if (quoteLineItem.invalidCustomQuantity) {
                        invalidCustomQuantity = true;
                    }
                }
            }
        } else if (cartItem.order) {
            title.textContent = `Reorder ${cartItem.order.invoiceNumber || ''}`;

            if (cartItem.order.orderProofs) {
                for (const orderProof of cartItem.order.orderProofs) {
                    if (!orderProof.proof) {
                        continue;
                    }
                    orderProof.proof.name = `Proof ${strings.TrimSuffix(orderProof.name || '', filepath.Ext(orderProof.name || ''))}`;
                    proofs.push(orderProof.proof);
                }
            }

            if (cartItem.order.orderLineItems) {
                for (const orderLineItem of cartItem.order.orderLineItems) {
                    if (orderLineItem.lineItemModel?.tax || orderLineItem.lineItemModel?.shipping) {
                        continue;
                    }

                    cartItemDescription.appendChild(drawCartItemLine(orderLineItem));

                    if (orderLineItem.orderProof?.proof?.id) {
                        shownProofs.add(orderLineItem.orderProof?.proof.id);
                    }

                    if (orderLineItem.invalidCustomQuantity) {
                        invalidCustomQuantity = true;
                    }
                }
            }
        } else if (cartItem.stockItem) {
            title.textContent = cartItem.stockItem.name || '';

            if (cartItem.stockItem.stockItemImage) {
                const cartItemImage = cartItemEl.querySelector<HTMLElement>('.cart-item-image');
                if (cartItemImage) {
                    cartItemImage.classList.remove('d-none');
                    const a = cartItemImage.querySelector('a');
                    if (a) {
                        a.href = cartItem.stockItem.stockItemImage.main || '';
                        a.setAttribute('data-fancybox', `cart-item-${cartItem.id || ''}`);
                        a.setAttribute('data-caption', cartItem.stockItem.name || '');
                    }
                    const img = cartItemImage.querySelector('img');
                    if (img) {
                        img.src = cartItem.stockItem.stockItemImage.thumbnail || '';
                        img.alt = cartItem.stockItem.name || '';
                        img.title = cartItem.stockItem.name || '';
                    }
                }
            }

            if (cartItem.customizations && Object.keys(cartItem.customizations).length) {
                for (const [key, value] of Object.entries(cartItem.customizations)) {
                    const customization = template.Clone('.cart-item-customization-template', cartItemEl).firstElementChild as HTMLElement;
                    const keyEl = customization.querySelector<HTMLElement>('.cart-item-customization-key');
                    if (keyEl) {
                        keyEl.textContent = key;
                    }

                    const valueEl = customization.querySelector<HTMLElement>('.cart-item-customization-value');
                    if (valueEl) {
                        valueEl.textContent = value;
                    }

                    cartItemDescription.appendChild(customization);
                }
            }

            const qtyContainer = cartItemEl.querySelector<HTMLElement>('.cart-item-quantity-container');
            qtyContainer?.classList.remove('d-none');

            const qty = qtyContainer?.querySelector<HTMLElement>('.cart-item-quantity');
            if (qty) {
                qty.textContent = new Intl.NumberFormat().format(cartItem.quantity || 0);
            }
        }

        if (invalidCustomQuantity) {
            placeOrder.setAttribute('disabled', 'disabled');
        } else {
            placeOrder.removeAttribute('disabled');
        }

        const footerProofs = cartItemEl.querySelector('.cart-item-footer-proofs') as HTMLElement;
        let footerHasProofs = false;

        for (const proof of proofs) {
            if (proof.id && shownProofs.has(proof.id)) {
                continue;
            }

            const proofLink = template.Clone('.cart-item-footer-proof', cartItemEl).firstElementChild as HTMLAnchorElement;
            const proofImg = proofLink.querySelector('img') as HTMLImageElement;
            if (proof?.main) {
                proofLink.href = proof.main;
                proofLink.setAttribute('data-fancybox', `cart-item-${cartItem.id || ''}`);
                proofLink.setAttribute('data-caption', proof.name || '');

                proofImg.src = proof.thumbnail || proof.main;

                proofImg.title = proof.name || '';
                proofImg.alt = proof.name || '';
            } else {
                proofLink.parentElement?.removeChild(proofLink);
            }

            footerProofs.appendChild(proofLink);
            footerHasProofs = true;
        }

        if (cartItem.cartItemUploads?.length) {
            const uploadEls: HTMLElement[] = [];
            for (const cartItemUpload of cartItem.cartItemUploads) {
                const upload = cartItemUpload.upload;
                if (!upload) {
                    continue;
                }

                const a = template.Clone('.cart-item-footer-proof', cartItemEl).firstElementChild as HTMLAnchorElement;
                a.href = `${window.cloudFront}/${upload.key || ''}`;
                a.setAttribute('data-fancybox', `cart-item-${cartItem.id || ''}`);
                a.setAttribute('data-caption', upload.name || '');

                uploadEls.push(a);

                footerProofs.appendChild(a);
                footerHasProofs = true;
            }

            uploads.LoadAll(uploadEls);
        }

        if (!footerHasProofs) {
            footerProofs.parentElement?.removeChild(footerProofs);
        }

        return cartItemEl;
    };

    void (async () => {
        const cartID = smgCarts.GetCartID();
        if (!cartID) {
            showEmptyCart();
            return;
        }

        const cartResp = await carts.GetCart();

        subtotal = Big(cartResp?.subtotal ?? 0);
        discount = Big(cartResp?.discount ?? 0);
        shipping = Big(cartResp?.shipping ?? 0);
        taxAmount = Big(cartResp?.taxAmount ?? 0);
        taxRate = Big(cartResp?.taxRate ?? 0);

        updateCartTotals();
        drawCartTotals();
        checkTaxState();
        await Promise.all([sess, balancePaymentOption, previousPaymentOption]).then(() =>
            updateUnmodifiedPaymentAmounts(),
        );

        if (!cartResp?.cart.cartItems?.length) {
            showEmptyCart();
            return;
        }

        spinner.parentElement?.removeChild(spinner);

        const frag = document.createDocumentFragment();

        let i = 0;
        for (const cartItem of cartResp.cart.cartItems) {
            if (i++) {
                const hr = document.createElement('hr') as HTMLElement;
                hr.classList.add('m-0');
                frag.appendChild(hr);
            }

            frag.appendChild(drawCartItem(cartItem));
        }

        frag.appendChild(editCart);

        cartCard.innerHTML = '';
        cartCard.appendChild(frag);
    })();
}